<script setup lang="ts">
import { RouterLink } from 'vue-router'
import type { BreadcrumbItem } from '../../types'

withDefaults(
  defineProps<{
    items?: BreadcrumbItem[]
  }>(),
  {
    items: () => []
  }
)

const navigable = (item: BreadcrumbItem) =>
  Boolean(item.href && item.href !== '#' && !item.isCurrent)
</script>

<template>
  <nav aria-label="Breadcrumb" class="c_breadcrumbs__container min-w-0 flex-1">
    <ul class="c_breadcrumbs">
      <li v-for="(item, index) in items" :key="`${item.label}-${index}`">
        <RouterLink
          v-if="navigable(item)"
          :to="item.href!"
          class="item"
          :title="index === 0 ? item.label : item.label"
          :aria-label="index === 0 ? item.label : undefined"
          :aria-current="undefined"
        >
          <component
            v-if="index === 0 && item.icon"
            :is="item.icon"
            class="h-4 w-4 shrink-0"
            aria-hidden="true"
          />
          <template v-else>{{ item.label }}</template>
        </RouterLink>
        <span
          v-else
          class="item"
          :aria-current="item.isCurrent ? 'page' : undefined"
          :title="item.label"
        >
          <component
            v-if="index === 0 && item.icon"
            :is="item.icon"
            class="h-4 w-4 shrink-0"
            aria-hidden="true"
          />
          <template v-else>{{ item.label }}</template>
        </span>
      </li>
    </ul>
  </nav>
</template>
